import React, { Component } from 'react';
import { Button, Popup } from 'semantic-ui-react';

export default class EstimateButton extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			canValuate: this.props.canValuate,
			hasAvailableValuations: this.props.hasAvailableValuations,
			popupOpen: false
		};
		
		this.click = this.click.bind(this);
		this.popupClose = this.popupClose.bind(this);
	}
	
	click() {
		
		const { canValuate, hasAvailableValuations } = this.state;
		
		if (!canValuate || !hasAvailableValuations)
		{
			this.setState({ popupOpen: true });
			
			setTimeout(this.popupClose, 2000);
		}
		else if (typeof HoverWindowDaemon !== "undefined" && typeof HoverWindowDaemon.Click === "function")
		{
			HoverWindowDaemon.Click("estimate");
		}
	}
	
	popupClose() {
		
		this.setState({ popupOpen: false });
	}
	
	render() {
		
		const { canValuate, hasAvailableValuations, popupOpen } = this.state;
		
		const button = <Button
			compact
			size="small"
			content={text.valuation}
			style={{ marginRight: "20px" }}
			icon="tag"
			onClick={this.click}
			color="blue"
			className="no-print"
		/>
		
		const content = (
			!hasAvailableValuations ? text.noRemainingEstimations : (
				!canValuate ? text.noPricesAvailable : ""
			)
		);
		
		return <Popup
			position="bottom center"
			style={{ color: "red" }}
			trigger={button}
			size="small"
			content={content}
			open={popupOpen}
		/>;
	}
}